import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import style from "./support.module.scss";
import { ListOfRequest, CreateRequest, CommentOnRequest, GetCommentsOnRequest } from "../../actions/APIcalls"
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Pagination from "../pagination/pagination";
import RequestCard from './reqLogCard/logCard'
import Button from "../Button/button"
import RequestModal from "./newRequestModal/newRequest"
import CommentModal from "../forum/commentModal/commentModal"


const supportLinks = [
    // { _id: 0, href: "tel:0902 227 8705", title: "شماره تماس", value: "۰۹۰۲ ۲۲۷ ۸۷۰۵", description: "پشتیبانی تلفنی شنبه تا چهارشنبه از ۹ تا ۱۸" },
    { _id: 1, href: "https://www.t.me/mobisha_support/", title: "چت تلگرام", value: "@mobisha_support", description: "پشتیبانی تلگرام هر روز از ۹ تا ۱۸" },
    { _id: 2, href: "https://www.t.me/mobishabot/", title: "ربات تلگرام", value: "@mobishabot", description: "برای مشاهده آخرین وضعیت محصولات" },
    { _id: 3, href: "/forum", title: "انجمن", value: "گفت‌وگو", description: "برای تبادل نظر درباره‌ی امکانات موبیشا" }
]

const Support = (props) => {

    const [requestsData, setRequestsData] = useState({
        requestList: [],
        totalPage: 1,
        totalRequests: 0,
    })

    const [newRequest, setNewRequest] = useState({
        isOpen: false
    })

    const [commentModal, setCommentModal] = useState({ open: false, data: null })

    useEffect(() => {
        getRequests();
    }, [])

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    const getRequests = async () => {
        let params = {
            page: parseInt(getFromUrl('page')) || 1,
            sortBy: 'createdAt',
            limit: parseInt(getFromUrl('countInPage')) || 10,
        }
        let res = await ListOfRequest(params)

        if (res && res.data && res.data.tweetData.length > 0) {
            let tmp = requestsData
            tmp.requestList = res.data.tweetData
            tmp.totalPage = res.data.totalPages
            tmp.totalRequests = res.data.totalTweet
            setRequestsData({
                ...tmp,
            })
        }
    }

    const getFromUrl = (param) => {
        const defaultParams = {
            countInPage: 10,
            page: 1,
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (url.get(param) === "true" || url.get(param) === "false") {
                return url.get(param) === "true" ? true : false;
            } else {
                return url.get(param)
            }
        } else {
            return defaultParams[param];
        }
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getRequests();
    }

    const sendRequest = async (params) => {
        let res = await CreateRequest(params)
        if (res && res.data) {
            getRequests();
            return true
        } else {
            return false
        }
    }

    const handleComment = async (request, page) => {
        let res = await GetCommentsOnRequest({ id: request._id, page: page })
        if (res && res.data) {
            let tmp = commentModal
            tmp.open = true
            tmp.data = {
                ...request,
                comments: res.data.commentData || [],
                page: res.data.page,
                totalPages: res.data.totalPages || 1,
                totalComment: res.data.totalComment || 1,
            }
            setCommentModal({ ...tmp })
        }
    }

    const addComment = async (data) => {
        let res = await CommentOnRequest(data)

        return res
    }

    return (
        <div className={style.wrapper}>
            <RequestModal
                value={newRequest.isOpen}
                parentClose={() => setNewRequest({ ...newRequest, isOpen: false })}
                sendRequest={sendRequest}
            />

            <CommentModal
                value={commentModal.open}
                data={commentModal.data}
                parentClose={() => setCommentModal({ ...commentModal, open: false })}
                addComment={addComment}
                getComments={handleComment}
            />

            <div className={style.header}>
                <h1>پشتیبانی</h1>
                <div className={style.buttonWrapper}>
                    <Button
                        disabled={false}
                        tag="newRequest"
                        type="solid"
                        label="درخواست جدید"
                        onclick={() => setNewRequest({ ...newRequest, isOpen: !newRequest.isOpen })}
                    />
                </div>
            </div>

            <div className={style.cardWrapper}>
                {supportLinks.map((supportItem, supportIndex) => <a
                    className={style.supportItem}
                    href={supportItem.href}
                    target="blank"
                    rel="noopener"
                    key={`supportIndex_${supportIndex}`}
                >
                    <>
                        <div className={style.iconWrapper}><div className={style.phoneIcon}></div></div>
                        <div className={style.supportTextWrapper}>
                            <p className={style.title}>{supportItem.title}</p>
                            <p className={style.amount}>{supportItem.value}</p>
                            <p className={style.description}>{supportItem.description}</p>
                        </div>
                    </>
                </a>)}
            </div>

            {requestsData.requestList.length > 0 && <div className={style.requests}>
                <div className={style.header}>
                    <h2>درخواست‌ها</h2>
                </div>

                {/* pagination */}
                <div className={style.paginationWrapper}>
                    <div className={style.pagination}>
                        <div className={style.Dropdown}>
                            <Pagination
                                tag="page"
                                currentPage={parseInt(getFromUrl("page"))}
                                pageCount={requestsData.totalPage}
                                setPage={setToUrl}
                            />
                            <div className={style.gap20}></div>
                            <TinyDropdown
                                placeholder={10}
                                dropdownList={["10", "25", "50", "75", "100"]}
                                selected={selected => {
                                    setToUrl(selected, 'countInPage')
                                }}
                                selectedItem={getFromUrl('countInPage')}
                            />
                            <div className={style.label}>تعداد نمایش در صفحه</div>
                            <div className={style.verticalLine}></div>
                            <div
                                className={style.variantCount}>{typeof requestsData.totalRequests !== 'undefined' ? toPersianNumber(requestsData.totalRequests) + " نتیجه" : ""}</div>
                        </div>
                    </div>
                </div>
                {/* pagination */}

                <div className={style.desktopTable}>
                    <div className={style.hiddenListShadow}></div>
                    <div className={style.logListWrapper}>
                        <div className={offset > 480 ? style.listHeaderFixed : style.listHeader}>
                            <div className={style.listHeaderItem45}>شماره</div>
                            <div className={style.listHeaderItem226}>متن</div>
                            <div className={style.listHeaderItem92}>تاریخ</div>
                            <div className={style.listHeaderItem123}>دسته‌بندی</div>
                        </div>
                        <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                        {requestsData.requestList.map((item, reqIndex) => <RequestCard
                            key={`reqIndex_${reqIndex}`}
                            data={item}
                            id={(parseInt(getFromUrl("page")) - 1) * parseInt(getFromUrl("countInPage")) + (reqIndex + 1)}
                            handleComment={handleComment}
                        />)}
                    </div>
                </div>

                <div className={style.paginationTwo}>
                    <Pagination
                        tag="page"
                        currentPage={parseInt(getFromUrl("page"))}
                        pageCount={requestsData.totalPage}
                        setPage={setToUrl}
                    />
                </div>
            </div>}
        </div>
    );
}

export default withRouter(Support);
